<template>
  <b-modal v-model="localShow" :title="title" @ok="handleOk" ok-variant="danger" no-close-on-backdrop no-close-on-esc
    centered hide-header-close>
    <template #modal-header="{ close }">
      <div class="d-flex justify-content-between align-items-center w-100">
        <h5 class="modal-title">{{ title }}</h5>
        <b-button variant="link" class="close-button" @click="close()">
          <i class="fas fa-times"></i>
        </b-button>
      </div>
    </template>

    <p class="my-4" v-html="message"></p>
    <template #modal-footer>
      <b-button size="sm" variant="secondary" @click="handleCancel">
        {{ $t('common.cancel') }}
      </b-button>
      <b-button size="sm" variant="danger" @click="handleOk">
        {{ $t('common.delete') }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import axios from "@/axios";

export default {
  name: 'ConfirmDeleteModal',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default() {
        return this.$t('common.confirm_delete'); // <-- use i18n translation key
      }
    },
    message: {
      type: String,
      default: 'Are you sure you want to delete this item? This action cannot be undone.'
    },
    itemId: {
      type: [String, Number],
      required: true
    },
    deleteUrl: {
      type: String,
      required: true
    },
    successMessage: {
      type: String,
      default: 'Item deleted successfully'
    },
    errorMessage: {
      type: String,
      default: 'Failed to delete item'
    }
  },
  data() {
    return {
      localShow: this.show,
      isDeleting: false
    }
  },
  watch: {
    show(newVal) {
      this.localShow = newVal;
    },
    localShow(newVal) {
      this.$emit('update:show', newVal);
    }
  },
  methods: {
    async handleOk() {
      if (this.isDeleting) return;

      try {
        this.isDeleting = true;
        await axios.delete(`${this.deleteUrl}/${this.itemId}`);
        this.$emit('deleted');
        this.localShow = false;
      } catch (error) {
        console.error('Error deleting item:', error);
        this.$bvToast.toast(error.response?.data?.message || this.errorMessage, {
          title: 'Error',
          variant: 'danger'
        });
      } finally {
        this.isDeleting = false;
      }
    },
    handleCancel() {
      this.localShow = false;
    }
  }
}
</script>